// Fecha del calendario local (YYYY-MM-DD). `toISOString()` da la fecha en UTC:
// en España, entre medianoche y las 01:00/02:00 devolvía todavía el día
// anterior y los filtros «hasta hoy» dejaban fuera lo de esa noche.
export function localISODate(date = new Date()) {
  const d = date instanceof Date ? date : new Date(date);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
